import { render, staticRenderFns } from "./qxzb.vue?vue&type=template&id=b18a7422&scoped=true&"
import script from "./qxzb.vue?vue&type=script&lang=js&"
export * from "./qxzb.vue?vue&type=script&lang=js&"
import style0 from "./qxzb.vue?vue&type=style&index=0&id=b18a7422&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18a7422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b18a7422')) {
      api.createRecord('b18a7422', component.options)
    } else {
      api.reload('b18a7422', component.options)
    }
    module.hot.accept("./qxzb.vue?vue&type=template&id=b18a7422&scoped=true&", function () {
      api.rerender('b18a7422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/scyxDrawer/components/qxzb.vue"
export default component.exports